@if (isControlOnly) {
  <div class="drawer-header-container" [ngClass]="rootClassName">
    @if (!!title) {
      <div class="drawer-header-control-title-container">
        <span class="drawer-header-control-title headingboldsmall">
          <span>{{title}}</span>
        </span>
        <span class="drawer-header-control-subtitle labelregularsmall">
          <span>{{subtitle}}</span>
        </span>
      </div>
    }
    @if (tabs.length > 1) {
      <div class="drawer-header-control-toggle-group">
        @for (tab of tabs; track $index) {
          <div class="drawer-header-control-toggle-item" [ngClass]="{'active': isActive(tab), 'disabled': isDisabled(tab)}" (click)="onToggle(tab)">
            <span class="drawer-header-control-label labelmediumsmall"><span>{{label(tab)}}</span></span>
          </div>
        }
      </div>
    }
    @if (isWeb) { <hr class="divider"/> }
  </div>
}

@if (!isControlOnly && !!title) {
  <div class="drawer-header-title-container">
    <span class="drawer-header-title labelregularsmall">
      <span>{{title}}</span>
    </span>
  </div>
}
